import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import DashboardLayout from "../../../layouts/DashboardLayout";

export default function ClienteServicioPage() {
    const [search, setSearch] = useState("");
    const [estado, setEstado] = useState("inactivo");

    return (
      <DashboardLayout>
        <Box sx={{ p: 3 }}>
          <Typography variant="h5" component="h1" gutterBottom>
              Listado de clientes
          </Typography>  
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
            <TextField
              label="Buscar cliente"
              variant="outlined"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size="small"
            />  
            <FormControl variant="outlined" size="small">
              <InputLabel id="estado-label">Estado</InputLabel>
              <Select
                labelId="estado-label"
                label="Estado"
                value={estado}
                onChange={(e) => setEstado(e.target.value)}
                sx={{ minWidth: 150 }}
              >
                <MenuItem value="activos">Activos</MenuItem>
                <MenuItem value="inactivo">Inactivo</MenuItem>
                <MenuItem value="todos">Todos</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Box>
      </DashboardLayout>
    );
}